import { ServiceHandler } from '../utils';

// from agency only
const getMyTeamsHandler = ServiceHandler({ url: '/api/auth/v1/teams/my' });
export const getMyTeams = (params: Record<string, unknown> = {}) =>
  getMyTeamsHandler({ params });

const applyChangesToTeamsHandler = ServiceHandler({
  url: '/api/account/v1/account/team/:accountId',
  method: 'post',
});
export const applyChangesToTeams = (
  { accountId }: { accountId: string | number },
  data?: unknown
) => applyChangesToTeamsHandler(accountId, { data });

// from cowbell only
const getTeamsForAgencyHandler = ServiceHandler({
  url: '/api/auth/v1/teams/agency/:agencyId',
});
export const getTeamsForAgency = ({
  agencyId,
  ...params
}: {
  agencyId: string | number;
  [key: string]: unknown;
}) => getTeamsForAgencyHandler(agencyId, { params });

// from cowbell only
const getTeamsForAgentInAgencyHandler = ServiceHandler({
  url: '/api/auth/v1/teams/user/:userId',
});
export const getTeamsForAgentInAgency = ({
  userId,
  ...params
}: {
  userId: string | number;
  [key: string]: unknown;
}) => getTeamsForAgentInAgencyHandler(userId, { params });
